export default __webpack_public_path__ + "static/media/soulection-in-motion.3d99eac5.png";